import { Dispatch, SetStateAction, createContext } from 'react';
import {
  DataRoomBuySideGroup,
  DataRoomMember,
} from '../../models/DataRoomMember';
import utils from 'utils';

type MembersContextProps = {
  isLoading: boolean;
  allMembers: DataRoomMember[];
  sellSideMembers: DataRoomMember[];
  buySideGroups: DataRoomBuySideGroup[];
  buySideMembers: DataRoomMember[];
  setSellSideMembers: Dispatch<SetStateAction<DataRoomMember[]>>;
  setBuySideGroups: Dispatch<SetStateAction<DataRoomBuySideGroup[]>>;
  updateMember: (updatedMember: Partial<DataRoomMember>) => void;
  updateBuySideGroup: (group: DataRoomBuySideGroup) => void;
};

export default createContext<MembersContextProps>({
  isLoading: false,
  allMembers: [],
  sellSideMembers: [],
  buySideGroups: [],
  buySideMembers: [],
  setSellSideMembers: utils.noop,
  setBuySideGroups: utils.noop,
  updateMember: utils.noop,
  updateBuySideGroup: utils.noop,
});
